import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'chroaZygosBelow';
const args = { color: CssVars.ColorFthora };

export class ChroaZygosBelow extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
